export default class AliasPasswordRenewal {
    constructor(public alias: string) {
    }
}
